import { Component, Input, OnInit } from '@angular/core';
import { IonRouterOutlet, ModalController, NavController, NavParams, Platform, ToastController } from '@ionic/angular';
import { FormControl, Validators, FormGroup } from '@angular/forms';
import { AlertController } from '@ionic/angular';
import { LoadingController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { Md5 } from 'ts-md5';
import { Observable, Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { LocationService } from '@shared/services/location.service';
import { Preferences } from '@capacitor/preferences';
import { UserService } from '@shared/services/user.service';
import { EmailValidationPage } from '../email-validation/email-validation.page';
import { UtilService } from '@shared/utils/util';
@Component({
  selector: 'app-signup-with-email',
  templateUrl: './signup-with-email.page.html',
  styleUrls: ['./signup-with-email.page.scss'],
  providers: [UserService, UtilService, IonRouterOutlet],
})
export class SignupWithEmailPage implements OnInit {
  @Input() referralUserId: string = '';
  public signupWithEmailForm = new FormGroup({
    emailControl: new FormControl('', Validators.compose([Validators.maxLength(50), Validators.email, Validators.required])),
    userpassControl: new FormControl('', Validators.compose([Validators.maxLength(15), Validators.required])),
    reenterpassControl: new FormControl('', Validators.compose([Validators.maxLength(15), Validators.required]))
  });
  submitAttempt: boolean = false;
  public userData: any = {};
  show: boolean = false;
  public backButton: Subscription | any;
  constructor(
    private modalCtrl: ModalController,
    private alertCtrl: AlertController,
    public loadingCtrl: LoadingController,
    private translate: TranslateService,
    public navParams: NavParams,
    private route: ActivatedRoute,
    public locationSvc: LocationService,
    public userService: UserService,
    public util: UtilService,
    public toastCtrl: ToastController,
    public navCtrl: NavController,
    public platform: Platform,
    private router: Router,
  ) {

  }

  ionViewWillEnter() {
    if (this.platform.is('android')) {
      this.backButton = this.platform.backButton.subscribe(() => {
        this.goBack();
      });
    }
  }

  ionViewWillLeave() {
    if (this.backButton) {
      this.backButton.unsubscribe();
    }
  }

  ngOnInit() {
  }
  goBack() {
    this.modalCtrl.dismiss();
  }

  async showModalAlert(message: string) {
    let alert = await this.alertCtrl.create({
      subHeader: message,
      buttons: [
        {
          text: 'OK',
          handler: () => { }
        }
      ]
    });

    await alert.present();
  }

  async showLoading(message: string) {
    const loading = await this.loadingCtrl.create({
      message: message,
      duration: 3000,
      // translucent: true,

      // backdropDismiss: true
    });

    loading.present();
  }

  async signMeUp() {
    this.submitAttempt = true;
    if (!this.signupWithEmailForm.valid) {
      this.showModalAlert(this.translate.instant('fixHighlighted'));
    }
    if (this.signupWithEmailForm.controls['userpassControl'].value != this.signupWithEmailForm.controls['reenterpassControl'].value) {
      this.showModalAlert(this.translate.instant('passwordsDontMatch'));
      return;
    }
    if (this.signupWithEmailForm.valid) {
      this.showLoading(this.translate.instant('pleaseWait'));


      let loader = this.loadingCtrl.create({
        message: this.translate.instant('pleaseWait'),
        // duration:10000
      });
      (await loader).present();

      let encryptedPass = Md5.hashStr(String(this.signupWithEmailForm.value.userpassControl));
      var theObs: Observable<any>;
      let browserLanguage = this.translate.getBrowserLang();

      this.userData = {
        referralUserId: this.referralUserId,
        email: String(this.signupWithEmailForm.controls['emailControl'].value),
        password: encryptedPass,
        needsEmailValidation: true,
        language: String(browserLanguage)
      }

      Preferences.get({ key: 'LAST_LOCATION' }).then(async (val) => {
        val = val.value ? JSON.parse(val.value) : null;
        let location = val;
        let teleportationLocation = this.locationSvc.getTeleportationLocation();
        if (teleportationLocation != null) {
          location = teleportationLocation;
        }

        // Retrieve and add FCM token to userData before sending to server
        const fcmToken = await Preferences.get({ key: 'TOKEN' });
        if (fcmToken && fcmToken.value) {
          this.userData.token = fcmToken.value;
          console.log('FCM token added to userData:', fcmToken.value);
        } else {
          console.log('No FCM token found in storage');
        }

        theObs = this.userService.upsertSoul(this.userData, location, false, false, true);

        theObs.subscribe(async data => {
          console.log('upsert subscribe entered');
          console.log(JSON.stringify(data));
          if (data != '{not ok}') {
            this.userData = JSON.parse(data);
            Preferences.set({ key: 'USER_DATA', value: JSON.stringify(this.userData) }).then(() => {
              console.log('userdata saved to DB');
            });

            (await loader).dismiss();

            this.showWelcomeBackMsg(this.userData);

            this.openEmailValidation();

          } else {
            (await loader).dismiss();
          }
        },
          async err => {
            console.log('Error: ' + JSON.stringify(err));
            (await loader).dismiss();
            this.util.showToastUnableToConnect(this.toastCtrl);
          }

        )
      })



    }
  }

  showWelcomeBackMsg(userData: any) {
    if (userData.wasOnHibernate != null) {
      this.showModalAlert(this.translate.instant('welcomeBackFromHibernate'));
    }
  }

  private async openEmailValidation() {
    const modal = this.modalCtrl.create({
      component: EmailValidationPage,
      componentProps: {
        referralUserId: this.referralUserId
      }

    });

    (await modal).onDidDismiss().then((val) => {
      if (val && val.data === "loggedIn") {
        this.modalCtrl.dismiss('loggedIn');
      }
    });



    (await modal).present();
  }


  async alreadyHaveValCode() {


    Preferences.get({ key: 'USER_DATA' }).then(async val => {
      this.userData = val.value ? JSON.parse(val.value) : null;
      if (this.userData != null) {
        console.log('alreadyHaveValCode - Got some data from Storage: ' + JSON.stringify(val));
        if (this.userData.tempValidationCode != null) {
          const modal = this.modalCtrl.create({ component: EmailValidationPage });
          (await modal).present();
        } else {
          this.showModalAlert(this.translate.instant('validationCodeExpired'));
        }
      } else {
        this.showModalAlert(this.translate.instant('validationCodeExpired'));
      }
    })
  }

  password() {
    this.show = !this.show;
  }

}
